export function buildAgentQuestionsFromObservations(observations) {
    const observationIds = new Set((observations || []).filter((row) => row.severity === "question").map((row) => row.questionId).filter(Boolean));
    const questions = [];
    if (observationIds.has("axis_name")) {
        questions.push({
            id: "axis_name",
            kind: "text",
            text: "使用する軸名を教えてください。例: X軸",
            placeholder: "例: X軸",
            quickOptions: ["X軸", "Y軸", "Z軸"],
            normalize: (value) => {
                const next = String(value || "").trim();
                if (!next) throw new Error("軸名を入力してください。");
                return /軸$/.test(next) ? next : `${next}軸`;
            }
        });
    }
    if (observationIds.has("off_branch")) {
        questions.push({
            id: "off_branch",
            kind: "choice",
            text: "OFF または未検知の分岐先を選んでください。",
            options: [
                { value: "wait", label: "待機" },
                { value: "end", label: "終了" },
                { value: "error", label: "エラー" }
            ]
        });
    }
    if (observationIds.has("timeout_sec")) {
        questions.push({
            id: "timeout_sec",
            kind: "text",
            text: "タイムアウト秒数を教えてください。",
            placeholder: "例: 5",
            quickOptions: ["3", "5", "10"],
            normalize: (value) => {
                const num = Number(value);
                if (!Number.isFinite(num) || num < 0) throw new Error("0 以上の数値を入力してください。");
                return String(num);
            }
        });
    }
    if (observationIds.has("error_code")) {
        questions.push({
            id: "error_code",
            kind: "text",
            text: "タイムアウト時のエラーコードを教えてください。",
            placeholder: "例: E101",
            quickOptions: ["E101", "E201", "E301"],
            normalize: (value) => {
                const next = String(value || "").trim().toUpperCase();
                if (!/^E\d{2,4}$/.test(next)) throw new Error("E101 のような形式で入力してください。");
                return next;
            }
        });
    }
    if (observationIds.has("after_motion")) {
        questions.push({
            id: "after_motion",
            kind: "choice",
            text: "最後の動作のあとをどうしますか。",
            options: [
                { value: "end", label: "そのまま終了" },
                { value: "next_motion", label: "次の動作へ進む" }
            ]
        });
    }
    return questions;
}

export function decideNextAgentAction(session) {
    if ((session.observations || []).some((row) => row.severity === "error")) return "failed";
    if ((session.questions || []).length) return "ask_user";
    return "validate";
}
